<div [@routeAnimations]="prepareRoute(outlet)" class="router-container" [ngClass]="{'collapsed': sidebarService.collapsed, 'is-mobile': sidebarService.isMobile,'login': !loginStatus}" color="primary">
  <router-outlet #outlet="outlet"></router-outlet>
</div>